import { fetchWithTokenRefresh } from './fetchWrapper';
import type { ApiResponse } from './api';
import type { Pack, PackActivitiesResponse } from '../types/pack.types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export const packsApi = {
  async getPacks(): Promise<Pack[]> {
    const response = await fetchWithTokenRefresh(`${API_URL}/packs`);
    if (response.status === 401) throw new Error('Please log in to continue.');
    const result: ApiResponse<Pack[]> = await response.json();
    if (!response.ok) {
      const msg = Array.isArray(result.error)
        ? result.error.join(', ')
        : result.error ?? 'Failed to fetch packs';
      throw new Error(msg);
    }
    if (!result.data) throw new Error('No data in response');
    return result.data;
  },

  async getPackActivities(
    packId: number,
    page: number,
    pageSize: number,
  ): Promise<PackActivitiesResponse> {
    const url = `${API_URL}/packs/${packId}/activities?page=${page}&pageSize=${pageSize}`;
    const response = await fetchWithTokenRefresh(url);
    if (response.status === 401) throw new Error('Please log in to continue.');
    const result: ApiResponse<PackActivitiesResponse> = await response.json();
    if (!response.ok) {
      const msg = Array.isArray(result.error)
        ? result.error.join(', ')
        : result.error ?? 'Failed to fetch pack activities';
      throw new Error(msg);
    }
    if (!result.data) throw new Error('No data in response');
    return result.data;
  },
};
